<template>
  <Modal v-model="mallRightFloatingInfoConfigModal" :title="$t('key1001851')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="mallRightFloatingInfoConfigChange">
    <Form ref="floatingInfoForm" :model="floatingInfoForm" :rules="ruleValidate" :label-width="145" @submit.native.prevent>
      <!--微信咨询-->
      <div class="section_title">{{ $t('key1000225') }}</div>
      <FormItem :label="$t('key1002378')" class="radio_styles">
        <RadioGroup v-model="wechatConfig.show">
          <Radio :label="1" class="mr30">{{ $t('key1002383') }}</Radio>
          <Radio :label="0">{{ $t('key1002384') }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('key1002379')" v-if="wechatConfig.show === 1">
        <Input v-model="wechatConfig.consultationTime" :placeholder="$t('key1002380')" style="width: 400px;"/>
      </FormItem>
      <FormItem :label="$t('key1002381')" prop="wechatQrCodeImg" class="required_style_label" v-show="wechatConfig.show === 1">
        <Upload
          class="upload_styles"
          type="drag"
          name="files"
          :headers="headObj"
          :action="fileApi"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList, 'wechat')"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="20480"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize">
          <div class="preview_box" v-if="wechatConfig.qrCodeImg">
            <img :src="wechatConfig.qrCodeImg"/>
            <div class="preview_mask">{{ $t('key1002385') }}</div>
          </div>
          <div class="upload_icon_box" v-else>
            <Icon type="md-add" size="28" color="#999" class="position-relative" style="top: 4px;"/>
            <span class="font-size-12">{{ $t('key1002386') }}</span>
          </div>
        </Upload>
      </FormItem>
      <!--电话咨询-->
      <div class="section_title mt10">{{ $t('key1000226') }}</div>
      <FormItem :label="$t('key1002378')" class="radio_styles">
        <RadioGroup v-model="phoneConfig.show">
          <Radio :label="1" class="mr30">{{ $t('key1002383') }}</Radio>
          <Radio :label="0">{{ $t('key1002384') }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('key1002379')" v-if="phoneConfig.show === 1">
        <Input v-model="phoneConfig.consultationTime" :placeholder="$t('key1002380')" style="width: 400px;"/>
      </FormItem>
      <FormItem :label="$t('key1000066')" prop="phonePhoneNumber" class="required_style_label" v-show="phoneConfig.show === 1">
        <Input v-model="phoneConfig.phone" :placeholder="$t('key1002382')" style="width: 400px;" @on-blur="validatePhone"/>
      </FormItem>
    </Form>
    <template #footer>
      <Button @click="mallRightFloatingInfoConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="mallRightFloatingInfoConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {handleUploadImageAddress, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'mallRightFloatingInfoConfigModal',
  mixins: [Mixin],
  data() {
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"&isOriginalName=true&isTemp=N',
      mallRightFloatingInfoConfigModal: false,
      configParamKey: null,
      wechatConfig: {
        show: 0,
        consultationTime: '',
        qrCodeImg: ''
      },
      phoneConfig: {
        show: 0,
        consultationTime: '',
        phone: ''
      },
      ruleValidate: {
        wechatQrCodeImg: [
          {validator: (rule, value, callback) => {
            if (this.wechatConfig.show === 1 && !value) {
              callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002373')));
            } else {
              callback();
            }
          }, trigger: 'change'}
        ],
        phonePhoneNumber: [
          {validator: (rule, value, callback) => {
            if (this.phoneConfig.show === 1 && !value) {
              callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002374')));
            } else {
              callback();
            }
          }, trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    // 表单校验模型映射（将嵌套config字段映射为扁平结构供iView Form使用）
    floatingInfoForm() {
      return {
        wechatQrCodeImg: this.wechatConfig.qrCodeImg,
        phonePhoneNumber: this.phoneConfig.phone
      };
    },
    // 获取当前登录用户信息
    userInfo() {
      return this.$store.state.erpConfig ? this.$store.state.erpConfig.userInfo : '';
    }
  },
  methods: {
    // 初始化弹窗并回显已保存的配置数据
    initMallRightFloatingInfoConfigData(paramKey, paramValue) {
      if (paramValue && typeof paramValue === 'object') {
        if (paramValue.wechatConfig) {
          this.wechatConfig = {
            show: paramValue.wechatConfig.show ?? 0,
            consultationTime: paramValue.wechatConfig.consultationTime || '',
            qrCodeImg: paramValue.wechatConfig.qrCodeImg || ''
          };
        }
        if (paramValue.phoneConfig) {
          this.phoneConfig = {
            show: paramValue.phoneConfig.show ?? 0,
            consultationTime: paramValue.phoneConfig.consultationTime || '',
            phone: paramValue.phoneConfig.phone || ''
          };
        }
      }
      this.configParamKey = paramKey;
      this.mallRightFloatingInfoConfigModal = true;
    },
    // 校验表单并提交配置
    mallRightFloatingInfoConfigBtn() {
      let allValid = true;
      // 微信咨询：展示时校验二维码必填
      if (this.wechatConfig.show === 1 && !this.wechatConfig.qrCodeImg) {
        allValid = false;
        this.setFieldError('wechatQrCodeImg', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002373'));
      }
      // 电话咨询：展示时校验电话必填
      if (this.phoneConfig.show === 1 && !this.phoneConfig.phone) {
        allValid = false;
        this.setFieldError('phonePhoneNumber', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002374'));
      }
      if (allValid) {
        this.submitConfig();
      }
    },
    // 执行保存配置
    submitConfig() {
      let obj = {
        wechatConfig: {
          show: this.wechatConfig.show,
          consultationTime: this.wechatConfig.show === 1 ? this.wechatConfig.consultationTime : '',
          qrCodeImg: this.wechatConfig.show === 1 ? this.wechatConfig.qrCodeImg : ''
        },
        phoneConfig: {
          show: this.phoneConfig.show,
          consultationTime: this.phoneConfig.show === 1 ? this.phoneConfig.consultationTime : '',
          phone: this.phoneConfig.show === 1 ? this.phoneConfig.phone : ''
        }
      };
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(obj),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.mallRightFloatingInfoConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 电话输入框失焦时校验
    validatePhone() {
      if (this.phoneConfig.show === 1 && !this.phoneConfig.phone) {
        this.setFieldError('phonePhoneNumber', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002374'));
      } else {
        this.clearFieldError('phonePhoneNumber');
      }
    },
    // 上传前校验图片格式和尺寸（尺寸要求≥170×170px）
    beforeUpload(file) {
      const allowTypes = ['image/png', 'image/jpeg'];
      if (!allowTypes.includes(file.type)) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002375'));
        return false;
      }
      // 尺寸校验（异步）
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const {width, height} = img;
          URL.revokeObjectURL(img.src);
          if (width < 170 || height < 170) {
            this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002367')} 170 × ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002368')} ${width} × ${height}px`);
            reject(false);
          } else {
            resolve(true);
          }
        };
        img.onerror = () => {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002376'));
          reject(false);
        };
      });
    },
    // 上传成功后更新图片地址并清除校验状态
    uploadSuccess(response, file, fileList, type) {
      if (response.code !== 0) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
        return;
      }
      if (type === 'wechat') {
        this.wechatConfig.qrCodeImg = handleUploadImageAddress(response.datas[0]);
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002377'));
        this.$nextTick(() => {
          this.clearFieldError('wechatQrCodeImg');
        });
      }
    },
    // 文件格式异常提示
    handleFormatError(file) {
      this.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002369')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002370')}`,
        duration: 5
      });
    },
    // 文件大小超限提示（上限20M）
    handleMaxSize(file) {
      this.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002371')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002372')}`,
        duration: 5
      });
    },
    // 弹窗关闭时重置数据和校验状态
    mallRightFloatingInfoConfigChange(value) {
      if (!value) {
        this.wechatConfig = {
          show: 0,
          consultationTime: '',
          qrCodeImg: ''
        };
        this.phoneConfig = {
          show: 0,
          consultationTime: '',
          phone: ''
        };
        this.configParamKey = null;
        this.$nextTick(() => {
          this.clearAllFieldErrors();
        });
      }
    },
    // 设置指定字段校验错误
    setFieldError(fieldName, message) {
      const formItem = this.$refs['floatingInfoForm'].fields?.find(f => f.prop === fieldName);
      if (formItem) {
        formItem.validateState = 'error';
        formItem.validateMessage = message;
      }
    },
    // 清除指定字段校验错误
    clearFieldError(fieldName) {
      const formItem = this.$refs['floatingInfoForm'].fields?.find(f => f.prop === fieldName);
      if (formItem) {
        formItem.validateState = '';
        formItem.validateMessage = '';
      }
    },
    // 清除所有字段校验错误
    clearAllFieldErrors() {
      const fields = this.$refs['floatingInfoForm']?.fields;
      if (fields) {
        fields.forEach(f => {
          f.validateState = '';
          f.validateMessage = '';
        });
      }
    }
  },
  watch: {
    // 微信咨询切换展示/隐藏时清除对应字段校验错误
    'wechatConfig.show'() {
      this.$nextTick(() => {
        this.clearFieldError('wechatQrCodeImg');
      });
    },
    // 电话咨询切换展示/隐藏时清除对应字段校验错误
    'phoneConfig.show'() {
      this.$nextTick(() => {
        this.clearFieldError('phonePhoneNumber');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.section_title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  padding: 5px 0 5px 0;
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 15px;
}

.radio_styles {
  /deep/ .ivu-form-item-label {
    font-size: 14px;
  }

  /deep/ label.ivu-radio-group-item {
    position: relative;
    top: 1px;
  }
}

.upload_styles {
  width: 122px;
}

.preview_box {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 4px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dcdfe6;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .preview_mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    cursor: pointer;
    transition: all 0.3s;
  }

  &:hover .preview_mask {
    opacity: 1;
  }
}

.upload_icon_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
